// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"0d31d9c4","222":"ed08c6cc","244":"8c6fa4f7","251":"35334109","340":"44582899","373":"4e09ccfb","453":"28a952f4","462":"b9f17ee9","477":"7a18dff9","599":"23b1fbf3","785":"9c7f14ef","930":"090e9760","967":"bd7d93db"}[chunkId] + ".chunk.js";
};